// Mirrors ACAA_SCREENING_FIELDS (features/notes/(v2)/(advanced-care)/constants)
// and reuses the note form's exact question wording — same 4 screening
// questions, just without the note's own per-question details textareas
// (client requirement: addendum only needs the one general comment box).
// Shared between AcaAddendumForm (edit mode) and AcaAddendumDisplay
// (read-only mode) so both stay in lockstep.
export const SCREENING_QUESTIONS = [
  {
    name: "acute_episode" as const,
    testId: "acuteEpisode",
    title: "ED visit or inpatient care for BH within 6 months?",
  },
  {
    name: "active_substance" as const,
    testId: "activeSubstance",
    title: "Active substance use disorder?",
  },
  {
    name: "sdoh" as const,
    testId: "sdoh",
    title: "Housing, Financial, or Safety Concerns (SDOH)?",
  },
  {
    name: "activity_difficulties" as const,
    testId: "activityDifficulties",
    title: "Difficulty with Activities of Daily Living (ADLs)?",
  },
];
